import "core-js";
import "@fullcalendar/react/dist/vdom";

import * as React from "react";
import { createRoot } from "react-dom/client";

import "@config/i18next";
import { initSentry } from "@config/sentry";
import { IS_DEV } from "@config/consts";

import { ORIGIN } from "@typings/globals";

import { App } from "@soft/containers";

// rerender detector
if (IS_DEV && process.env.ENABLE_DETECT_RERENDER === "true") {
  require("../@services/DetectRerender/DetectRerender");
}

initSentry(ORIGIN.BATSOFT);

const cleanup = () => {
  const preloadStyled = document.querySelector("#preload");

  if (preloadStyled) {
    preloadStyled.parentNode &&
      preloadStyled.parentNode.removeChild(preloadStyled);
  }
};

const container = document.getElementById("app");
const root = createRoot(container!);
root.render(<App />);

cleanup();
